export default {
	title: 'Bienvenue sur le site',
	subTitle: 'Questionnaires Risques Professionnels',
	card: {
		salarie: {
			title: 'Salarié(e)',
			content: 'Vous êtes salarié(e) et vous avez une déclaration d\'accident de travail ou de maladie professionnelle en cours.'
		},
		employeur: {
			title: 'Employeur',
			content: 'Vous êtes représentant légal d\'une entreprise et un(e) de vos salarié(e)s a une déclaration d\'accident de travail ou de maladie professionnelle en cours.'
		},
		employeurParticulier: {
			title: 'Employeur particulier',
			content: 'Vous êtes employeur particulier et une personne que vous employez a une déclaration d\'accident de travail ou de maladie professionnelle en cours.'
		},
		temoin: {
			title: 'Témoin',
			content: 'Vous avez été cité en tant que témoin concernant un accident de travail ou de trajet ? Pour accéder au questionnaire, merci de saisir le code que vous avez reçu.',
			code: 'Saisir votre code'
		}
	}
};
